export const WLandingSlogan = `임직원을 위한 모든 복지
개방형 복지몰, 복지대장`;

export const WFooterTitle = `임직원을 위한 진짜 복지 혜택`;
export const WFooterDesc = `네이버파이낸셜과 벤디스가 함께 제공하는 편리한 개방형 복지서비스`;

export const WBannerTitle = `복지대장으로 복지포인트 관리`;

export const wCardRowTitle = `모두에게 필요한 복지대장`;

export const WBannerTab01 = `복지포인트 지급/차감`;
export const WBannerTab02 = `복지포인트 사용 내역`;

export const WelfareLandingTitle01 = `원하는 날, 원하는 시간에
웹으로 간편 예약`;

export const WelfareLandingDesc01 = `복지대장은 24시간 곁에 있어요.
필요한 날짜와 시간에 언제든 예약 및 호출이 가능합니다.`;

export const WelfareLandingItem01 = `24시간 운영 및 예약`;
export const WelfareLandingItem02 = `PC 간편 예약`;

export const WelfareLandingTitle02 = `눈에 보이는 배송과정`;

export const WelfareLandingDesc02 = `접수부터 완료까지,
모든 현황을 알림과 웹을 통해 확인할 수 있습니다.`;

export const WelfareLandingTitle03 = `제대로 복지한 복지`;

export const WelfareLanding03ItemTitle01 = `경로 최적화 시스템`;
export const WelfareLanding03ItemDesc01 = `실시간 교통상황을 반영한
경로 최적화로 신속하게 배송합니다`;

export const WelfareLanding03ItemTitle02 = `대규모 차량 네트워크`;
export const WelfareLanding03ItemDesc02 = `2륜부터 25톤 화물차까지 물품에
적합한 차량으로 빠르게 배차 합니다.`;

export const WelfareLanding03ItemTitle03 = `안전 운송 드라이버`;
export const WelfareLanding03ItemDesc03 = `엄격한 승인 절차와 교육을 통해
14,000명의 기사님이 안전배송합니다.`;

export const WelfareLandingTitle04 = `개인이 이용해도 관리는 통합으로`;

export const WelfareLandingDesc04 = `우리팀 모두 편해지는 간편 관리 시스템`;

export const WelfareLandingTitle0401 = `상세 이용내역 조회`;
export const WelfareLandingDesc0401 = `회사에서 이용한 모든 내역을 한 눈에 확인할 수 있습니다.`;

export const WelfareLandingTitle0402 = `사용 통계 조회`;
export const WelfareLandingDesc0402 = `회사에서 이용한 모든 내역을 한 눈에 확인할 수 있습니다.`;

export const WelfareLandingTitle0403 = `사용자 관리`;
export const WelfareLandingDesc0403 = `회사에서 이용한 모든 내역을 한 눈에 확인할 수 있습니다.`;

export const WelfareLandingTitle05 = `필요했던 깔끔 정산`;
export const WelfareLandingDesc05 = `월말 세금계산서 한 장으로 비용 증빙도 간편해집니다.`;

export const WelfareLandingTitle055 = `투명한 요금 체계로 기업 비용 절감 효과까지`;
export const WelfareLandingDesc055 = `거리 단위 표준단가로 책정된 합리적인 요금을 사전에 확인할 수 있습니다.`;

export const WelfareLandingTitle06 = `식대부터 복지까지, 분산된 기업 비용을 하나로 통합관리!`;
export const WelfareLandingDesc06 = `가장 필요했던 비즈니스 복지, 지금 경험해보세요`;
